/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  labelLastModification: {
    id: "b2b.konfiguracni-parametry-editace-widget.label.last-modification",
    defaultMessage: "Last modification"
  },
  title: {
    id: "b2b.konfiguracni-parametry-editace-widget.title",
    defaultMessage: "Portal Configuration Parameters"
  },
  buttonSubmit: {
    id: "b2b.konfiguracni-parametry-editace-widget.submit",
    defaultMessage: "Save"
  },
  saveDialogTitle: {
    id: "b2b.konfiguracni-parametry-editace-widget.save-daialog.title",
    defaultMessage: "Saving Portal Parameters"
  }
});

export default () => useMessages(MESSAGES);
